import { useEffect, useRef, useState } from 'react';

const RESIZE_RELOAD_DELAY = 250;

const getViewportSize = () => ({
	width: window.innerWidth,
	height: window.innerHeight,
	visualViewportWidth: window.visualViewport?.width,
	visualViewportHeight: window.visualViewport?.height,
});

const useTimeGameResizeReloadKey = () => {
	const [reloadKey, setReloadKey] = useState(0);
	const viewportSizeRef = useRef(getViewportSize());
	const resizeTimeoutRef = useRef<number | null>(null);

	useEffect(() => {
		const handleResize = () => {
			if (resizeTimeoutRef.current != null) {
				window.clearTimeout(resizeTimeoutRef.current);
				resizeTimeoutRef.current = null;
			}

			resizeTimeoutRef.current = window.setTimeout(() => {
				const nextViewportSize = getViewportSize();
				const previousViewportSize = viewportSizeRef.current;

				const viewportHasChanged =
					nextViewportSize.width !== previousViewportSize.width ||
					nextViewportSize.height !== previousViewportSize.height ||
					nextViewportSize.visualViewportWidth !== previousViewportSize.visualViewportWidth ||
					nextViewportSize.visualViewportHeight !== previousViewportSize.visualViewportHeight;

				if (!viewportHasChanged) {
					return;
				}

				viewportSizeRef.current = nextViewportSize;
				setReloadKey((key) => key + 1);
				resizeTimeoutRef.current = null;
			}, RESIZE_RELOAD_DELAY);
		};

		window.addEventListener('resize', handleResize);
		window.addEventListener('orientationchange', handleResize);
		window.visualViewport?.addEventListener('resize', handleResize);

		return () => {
			if (resizeTimeoutRef.current != null) {
				window.clearTimeout(resizeTimeoutRef.current);
				resizeTimeoutRef.current = null;
			}

			window.removeEventListener('resize', handleResize);
			window.removeEventListener('orientationchange', handleResize);
			window.visualViewport?.removeEventListener('resize', handleResize);
		};
	}, []);

	return reloadKey;
};

export default useTimeGameResizeReloadKey;
